;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Router = APP.module('Router');
	var Model = APP.module('Model');
	Router.Tipping = Marionette.AppRouter.extend({
		permissions: {
			'gamesList':          1,
			'leaguesList':        1,
			'leaguesJoin':        1,
			'leaguesCreate':      1,
			'leaguesLadder':      1,
			'leaguesInvites':     1,
			'leaguesCelebrities': 1,
			'leaguesUsers':       1,
			'leaguesSettings':    1,
			'leaguesAbout':       1,
			'leaguesJoinByCode':  1,
			'rankings':           1,
			'ladder':             3,
			'contacts':           3,
			'leaguesTipsList':    1
		},
		appRoutes:   {
			'tipping(/)':                                    'gamesList',
			'tipping/leagues':                               'leaguesList',
			'tipping/leagues/join':                          'leaguesJoin',
			'tipping/leagues/create(/:league_name)':         'leaguesCreate',
			'tipping/leagues/:league_id/ladder':             'leaguesLadder',
			'tipping/leagues/:league_id/about':              'leaguesAbout',
			'tipping/leagues/:league_id/manage(/invites)':   'leaguesInvites',
			'tipping/leagues/:league_id/manage/celebrities': 'leaguesCelebrities',
			'tipping/leagues/:league_id/manage/users':       'leaguesUsers',
			'tipping/leagues/:league_id/settings':           'leaguesSettings',
			'tipping/leagues/:league_id/join/:league_code':  'leaguesJoinByCode',
			'tipping/rankings':                              'rankings',
			'tipping/ladder':                                'rankings',
			'contacts':                                      'rankings',
			'tipping/leagues/:league_id/league_tips_list':   'leaguesTipsList'
		}
	});

}(window, APP, Backbone, Marionette, $, _));